var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClockOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9 9"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10",
    d: "M4.5 0A4.5 4.5 0 109 4.5 4.5 4.5 0 004.5 0zm0 8.1a3.6 3.6 0 113.6-3.6 3.6 3.6 0 01-3.6 3.6zm.225-5.85H4.05v2.7l2.362 1.417.338-.553-2.025-1.2z",
    fill: "inherit"
  })));
}

export default SvgClockOutline;